// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3FNNb","content":"styles_content__1tpLr","selectAll":"styles_selectAll__2UGNC"};